import * as React from "react"
import { useSearchParams } from "react-router-dom"

/**
 * A list selection kept in one search param (`?person=…`), so a reload or a shared link opens the same item.
 * It always writes with `replace`: moving through a list (by click or arrow key) must not leave one history
 * entry per item.
 */
export function useSearchParamSelection(param: string): [string | null, (id: string) => void] {
  const [searchParams, setSearchParams] = useSearchParams()
  const value = searchParams.get(param)

  const select = React.useCallback(
    (id: string) => {
      setSearchParams(
        (current) => {
          if (current.get(param) === id) return current
          const next = new URLSearchParams(current)
          next.set(param, id)
          return next
        },
        { replace: true },
      )
    },
    [param, setSearchParams],
  )

  return [value, select]
}
